import { render } from "./HeroLiquidationStatus.vue?vue&type=template&id=54557b81&scoped=true"
import script from "./HeroLiquidationStatus.vue?vue&type=script&lang=js"
export * from "./HeroLiquidationStatus.vue?vue&type=script&lang=js"

import "./HeroLiquidationStatus.vue?vue&type=style&index=0&id=54557b81&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54557b81"]])

export default __exports__